import CircularProgress from "@mui/material/CircularProgress";
import { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PageLayout from "./components/layout/PageLayout";
import { webStyle as theme } from "./components/layout/Theme";
import LanguageRouter from "./components/LanguageRouter";

import AnalyticsPage from "./view/Analytic";
import ReportPage from "./view/Report";
import ForgotPassword from "./view/authentication/ForgotPassword";
import LoginPage from "./view/authentication/Login";
import ResetPassword from "./view/authentication/ResetPassword";
import SignUpPage from "./view/authentication/SignUp";
import InvitationPage from "./view/management/InvitationPage";
import DeviceManagement from "./view/management/device/DeviceManagement";
import SiteAddEditPage from "./view/management/site/SiteAddEditPage";
import SiteMainPage from "./view/management/site/SiteMainPage";
// import PaymentPage from "./view/payment";
// import TariffPage from "./view/tariff";

// import CarbonEventDashboard from "./view/carbonEvent/CarbonEventDashboard";
// import CarbonEventDashboardView from "./view/carbonEvent/CarbonEventDashboardView";
// import EventController from "./view/carbonEvent/EventController";
// import EventSurveyPage from "./view/carbonEvent/EventSurvey";
// import EventSurveyCompleted from "./view/carbonEvent/EventSurveyCompleted";
import DataSourceManagement from "./view/management/data-source/DataSourceManagement";
import ESG from "./view/management/data-source/ESG/ESG";

//company dashboard
import AddNewWidget from "./view/management/widgets/addNewWidget";

//dashboards
// import EventInformationPage from "./view/EventInfomation";
// import EventTransactionPage from "./view/EventTransaction";
import SignageTvDashboard from "./view/dashboards/signageTv/SignageTvDashboard";
// import ElectricityEmissionDashboard from "./view/dashboards/electricity-emission-dash";

import ShippingTransactionList from "./view/management/PAT";
import MicroServiceDap from "./view/management/dap/MicroServiceDap";
import NTSSO from "./view/authentication/SSO/ntSSO";

// customer management system
import DeviceInterface from "./components/device_management/interface";
import { ProtectedRoutes } from "./utils/ProtectedRoutes";
import PolicyPage from "./view/PolicyPage";
import InfoDetails from "./view/authentication/InfoDetails";
import Verify from "./view/authentication/Verify";
import EarnPointsTransactions from "./view/cutomerManagement/Transactions";
// import TaskManagement from "./view/management/task-management/TaskManagement";

const ProfilePage = lazy(() => import("./view/management/user/ProfilePage"));
// const OverviewPage = lazy(() => import('./view/Overview'));
const Dashboard = lazy(() => import("./view/Dashboard"));
const SitePage = lazy(() => import("./view/Site"));
const SettingPage = lazy(() => import("./view/Setting"));
const Users = lazy(() => import("./view/User"));

//satellite dashboard
// tarriff and payment

const Loading = () => {
  return (
    <div className="h-screen">
      <div className="flex items-center justify-center w-full h-full">
        <CircularProgress
          size={100}
          style={{ color: theme["Theme"]["main"] }}
          disableShrink
        />
      </div>
    </div>
  );
};

const AppRouter = () => {
  return (
    <>
    <Suspense fallback={<Loading />}>
  <LanguageRouter>
    <Routes>
      {/* used for the microsoft-auth redirect */}
      <Route path="/blank" element={<div></div>} />
      <Route path="*" element={<Navigate to={"/en"} />} />

      {/* Public routes without language prefix */}
      <Route path="/login" element={<LoginPage isDap={false} />} />
      <Route path="/login/nt" element={<NTSSO />} />

      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/set-up-company" element={<InfoDetails />} />
      <Route path="/forget-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/invitation/:invitationID" element={<InvitationPage />} />
      {/* <Route path="/event-survey" element={<EventSurveyPage />} />
      <Route path="/event-controller" element={<EventController />} />
      <Route path="/event-dashboard" element={<CarbonEventDashboardView />} />
      <Route path="/event-survey-completed" element={<EventSurveyCompleted />} /> */}
      <Route path="/privacy-policy" element={<PolicyPage />} />
      <Route path="/esg/:companyId/view/:key" element={<ESG />} />

      {/* Protected routes with language prefix */}
      <Route element={<ProtectedRoutes />}>
        <Route path="/:lang" element={<SitePage />} />
        {/* <Route path="/:lang/entity/add" element={<EntityAddPage />} /> */}
        
        {/* new incoming changes */}
        <Route path="/:lang/plant/dashboard/" element={<PageLayout><Dashboard /></PageLayout>} />
        <Route path="/:lang/plant/dashboard/setup" element={<PageLayout><SettingPage /></PageLayout>} />
        
        <Route path="/:lang/plant/dashboard/:dashboardId" element={<PageLayout><Dashboard /></PageLayout>} />
        <Route path="/:lang/plant/dashboard/view/:dashboardId" element={<Dashboard hideHeader={true} />} />
        <Route path="/:lang/plant/dashboard/setup/:dashboardId" element={<PageLayout><SettingPage /></PageLayout>} />
        <Route path="/:lang/plant/widget/add/:dashboardId" element={<PageLayout><AddNewWidget /></PageLayout>} />
        
        <Route path="/:lang/company/dashboard/:dashboardId" element={<PageLayout><Dashboard isCompany={true} /></PageLayout>} />
        <Route path="/:lang/company/dashboard/setup/:dashboardId" element={<PageLayout><SettingPage isCompany={true} /></PageLayout>} />
        <Route path="/:lang/company/widget/add/:dashboardId" element={<PageLayout><AddNewWidget isCompany={true} /></PageLayout>} />
       
        <Route path="/:lang/profile" element={<PageLayout><ProfilePage /></PageLayout>} />
        <Route path="/:lang/setting" element={<PageLayout><Users /></PageLayout>} />
       
        <Route path="/:lang/device-management" element={<PageLayout><DeviceManagement /></PageLayout>} />
        <Route path="/:lang/device-management/:plantId/interface" element={<PageLayout><DeviceInterface /></PageLayout>} />
        {/* <Route path="/:lang/task-management" element={<PageLayout><TaskManagement /></PageLayout>} /> */}
        <Route path="/:lang/data-source-mng" element={<PageLayout><DataSourceManagement /></PageLayout>} />
        
        <Route path="/:lang/site" element={<PageLayout><SiteMainPage /></PageLayout>} />
        <Route path="/:lang/site/add" element={<PageLayout><SiteAddEditPage isEdit={false} /></PageLayout>} />
        <Route path="/:lang/site/edit/:id" element={<PageLayout><SiteAddEditPage isEdit={true} /></PageLayout>} />
        <Route path="/:lang/pat" element={<PageLayout><ShippingTransactionList /></PageLayout>} />
        <Route path="/:lang/dap-service" element={<PageLayout><MicroServiceDap /></PageLayout>} />
        <Route path="/:lang/customer-management-system" element={<PageLayout><EarnPointsTransactions /></PageLayout>} />
        {/* <Route path="/:lang/carbon-event" element={<PageLayout><CarbonEventDashboard /></PageLayout>} /> */}
        {/* <Route path="/:lang/event-transaction" element={<PageLayout><EventTransactionPage /></PageLayout>} /> */}
        {/* <Route path="/:lang/event-information/:eventId" element={<PageLayout><EventInformationPage /></PageLayout>} /> */}
        <Route path="/:lang/report" element={<PageLayout><ReportPage /></PageLayout>} />
        <Route path="/:lang/analytics" element={<PageLayout><AnalyticsPage /></PageLayout>} />
        {/* <Route path="/:lang/tariff" element={<PageLayout><TariffPage /></PageLayout>} /> */}
        {/* <Route path="/:lang/payment" element={<PageLayout><PaymentPage /></PageLayout>} /> */}
        <Route path="/:lang/signage/:dashboardId" element={<SignageTvDashboard />} />
        <Route path="/:lang/esg" element={<PageLayout><ESG /></PageLayout>} />
      </Route>
    </Routes>
  </LanguageRouter>
</Suspense>

    </>
  );
};

export default AppRouter;
